const FinancePage = () => import("@/views/admin/FinancePage");

const ProjectSettings = () => import("@/views/user/architect/ProjectSettings");
const MyProfile = () => import("@/views/admin/profile/MyProfile");
const MyProfileSettings = () =>
  import("@/views/admin/profile/MyProfileSettings");
const UserView = () => import("@/views/admin/profile/UserView"); //Do zmiany widok
const AdminUserView = () => import("@/views/admin/users/UserView"); //Do zmiany widok
import { Role } from "@/helpsers/role.helper";
const AllProducts = () => import("@/views/admin/products/AllProducts");
const ProductsView = () => import("@/views/admin/products/ProductsView");
const ShopProducts = () => import("@/views/admin/products/ShopProducts");
const HomePage = () => import("@/views/admin/HomePage");
const Suppliers = () => import("@/views/admin/users/Suppliers");
const Ewoods = () => import("@/views/admin/users/Ewoods");
import UserService from "@/services/user.service";
import AdminLayout from "@/layouts/AdminLayout";
const StyleQuiz = () => import("@/views/admin/StyleQuiz");
const ProducersView = () => import("@/views/admin/ProducersView");
const OrdersView = () => import("@/views/admin/orders/OrdersView");
const ProjectDetails = () => import("@/views/user/architect/ProjectDetails");
const DetailProducts = () => import("@/views/admin/products/DetailProducts");
const StyleQuizSteps = () => import("@/views/admin/StyleQuizSteps");

const routes = [
  {
    path: "/admin",
    component: HomePage,
    name: "admin.homepage",
    meta: {
      title: "Home Page",
      authorize: [Role.Admin],
      layout: AdminLayout,
    },
  },
  {
    path: "/admin/my-profile",
    component: UserView,
    beforeEnter: () => {
      const userService = new UserService();
      userService.getUserInfo();
    },
    children: [
      {
        path: "",
        name: "admin.profile",
        component: MyProfile,
        meta: {
          title: "Profil",
          authorize: [Role.Admin],
          layout: AdminLayout,
        },
      },
      {
        path: "settings",
        name: "admin.settings",
        component: MyProfileSettings,
        meta: {
          title: "Ustawienia profilu",
          authorize: [Role.Admin],
          layout: AdminLayout,
        },
      },
    ],
  },
  {
    path: "/admin/products",
    component: ProductsView,
    children: [
      {
        path: "all",
        name: "admin.products.all",
        component: AllProducts,
        meta: {
          title: "Wszystkie produkty",
          authorize: [Role.Admin],
          parent: "admin.products",
          layout: AdminLayout,
        },
      },
      {
        path: "shop",
        name: "admin.products.shop",
        component: ShopProducts,
        meta: {
          title: "Produkty na sklepie",
          authorize: [Role.Admin],
          parent: "admin.products",
          layout: AdminLayout,
        },
      },
      {
        path: ":id",
        name: "admin.products.detail",
        component: DetailProducts,
        meta: {
          title: "Produkty na sklepie",
          authorize: [Role.Admin],
          parent: "admin.products",
          layout: AdminLayout,
        },
      },
    ],
  },
  {
    path: "/admin/users",
    component: AdminUserView,
    children: [
      {
        path: "suppliers",
        name: "admin.users.suppliers",
        component: Suppliers,
        meta: {
          title: "Dostawcy",
          authorize: [Role.Admin],
          parent: "admin.users",
          layout: AdminLayout,
        },
      },
      {
        path: "ewoods/:role",
        name: "admin.users.ewoods",
        component: Ewoods,
        meta: {
          title: "Ewoods",
          authorize: [Role.Admin],
          parent: "admin.users",
          layout: AdminLayout,
        },
      },
    ],
  },
  {
    path: "/admin/producers",
    name: "admin.producers",
    component: ProducersView,
    meta: {
      title: "Producenci",
      authorize: [Role.Admin],
      layout: AdminLayout,
    },
  },
  {
    path: "/admin/style-quiz",
    name: "admin.style-quiz",
    component: StyleQuiz,
    meta: {
      title: "Style quiz",
      authorize: [Role.Admin],
      layout: AdminLayout,
    },
  },
  {
    path: "/admin/orders",
    name: "admin.orders",
    component: OrdersView,
    meta: {
      title: "Zamówienia",
      authorize: [Role.Admin],
      layout: AdminLayout,
    },
  },
  {
    path: "/admin/finance",
    name: "admin.finance",
    component: FinancePage,
    meta: {
      title: "Finanse",
      authorize: [Role.Admin],
      layout: AdminLayout,
    },
  },
  {
    path: "/admin/style-quiz-steps",
    name: "admin.style-quiz-steps",
    component: StyleQuizSteps,
    meta: {
      title: "Etapy style quiz",
      authorize: [Role.Admin],
      layout: AdminLayout,
    },
  },
  {
    path: "/projects",
    component: UserView,
    children: [
      {
        path: "settings/:id",
        name: "admin.project-settings",
        component: ProjectSettings,
        beforeEnter: (to) => {
          const userService = new UserService();
          userService.getUserInfo();
        },
        meta: {
          title: "Ustawienia projektu",
          authorize: [Role.Admin],
          layout: AdminLayout,
        },
      },
    ],
  },
  {
    path: "/admin/projects/details/:id/:activeTab?/:nestedTab?",
    name: "admin.project-details",
    component: ProjectDetails,
    beforeEnter: (to) => {
      const userService = new UserService();
      userService.getUserInfo();
    },
    meta: {
      title: "Szczegóły projektu",
      authorize: [Role.Admin],
      layout: AdminLayout,
    },
  },
];

export default routes;
